module.exports = __webpack_public_path__ + "img/arrow.7511fd8f.svg";